import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge provided class values using clsx and tailwind-merge into a single string.
 *
 * @param inputs Class values (strings, arrays, objects, falsy) accepted by clsx.
 * @returns Merged class name string with Tailwind conflicts resolved.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
